// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line import/no-named-as-default
import HelloSign from "hellosign-embedded";

import { environmentConfig } from "../environment";

export const helloSignClient = new HelloSign({
  clientId: environmentConfig.REACT_APP_HELLOSIGN_APP_CLIENT_ID,
});
